var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldCardEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.538c0 .67-.54 1.21-1.21 1.21H3.21c-.68 0-1.21-.56-1.21-1.23.01-1.13.46-2.16 1.21-2.91S5 3.398 6.14 3.398h6.15c.67 0 1.21.54 1.21 1.21v2.93z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 16.46c0 2.29 1.85 4.14 4.14 4.14h11.71c2.29 0 4.15-1.86 4.15-4.15v-4.99c0-.67-.54-1.21-1.21-1.21H3.21c-.67 0-1.21.54-1.21 1.21v5zm4 .79c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h2c.41 0 .75.34.75.75s-.34.75-.75.75H6zm4.5 0c-.41 0-.75-.34-.75-.75s.34-.75.75-.75h4c.41 0 .75.34.75.75s-.34.75-.75.75h-4zM17.03 1.75c-1.27 0-2.03.76-2.03 2.03v2.94c0 1.27.76 2.03 2.03 2.03h2.94c1.27 0 2.03-.76 2.03-2.03V3.78c0-1.27-.76-2.03-2.03-2.03h-2.94zm.83 5.64-1.04.15a.34.34 0 0 1-.1.01c-.15 0-.28-.05-.37-.15a.528.528 0 0 1-.14-.47l.15-1.04c.01-.05.04-.12.07-.15l1.7-1.7c.03.07.06.15.09.23.04.08.08.15.12.22.03.06.07.12.11.16.04.06.08.12.11.15a1.848 1.848 0 0 0 .32.33c.02.02.04.04.05.04.05.04.11.09.15.12.06.04.11.08.17.11.07.04.15.08.23.12.08.04.16.07.23.09l-1.7 1.71c-.03.03-.1.07-.15.07zm2.21-2.13c-.01.02-.04.03-.07.03h-.03c-.72-.21-1.29-.78-1.5-1.5-.01-.04 0-.08.03-.11l.33-.33c.54-.54 1.05-.53 1.58 0 .27.27.4.53.4.79-.01.26-.14.52-.41.79l-.33.33z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldCardEdit);
export default __webpack_public_path__ + "static/media/vuesax-bold-card-edit.66423e74c9048db53d8b0a4d16b74f36.svg";
export { ForwardRef as ReactComponent };